var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',{attrs:{"title":_vm.$t('pages.starter.title')}}),_c('starter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }